module.exports = __webpack_public_path__ + "img/NewsCenterDetails_pic1.c2347559.png";